export interface ISidebarState {
    setApprovedExpenseTypes: (value: Set<number>) => void;
    setApprovedLineItemIds?: (value: Set<number>) => void;
    setActiveExpenseType: (value: number | null) => void;
    setActiveExpenseTypeFileIndex: (value: Map<number, number>) => void;
}

